import { Flex, IconButton, Input, Popover, Portal, Tag } from '@lego/klik-ui';
import { Filter, FilterBold } from '@lego/klik-ui/icons';
import type { RowData } from '@tanstack/react-table';
import { useState } from 'react';
import type { Column } from '../appTable';

export const MultiSearchFilter = <T extends RowData>({ column }: { column: Column<T> }) => {
  const [inputValue, setInputValue] = useState<string>('');
  const filterValue = (column.getFilterValue() as unknown[]) ?? [];

  const handleInputUpdate = (event: React.ChangeEvent<HTMLInputElement>) => {
    const constraint =
      column.columnDef.meta?.filterVariant?.type === 'multiSearch' &&
      column.columnDef.meta.filterVariant.constraint;

    if (constraint && !event.target.value.match(constraint)) return;
    setInputValue(event.target.value);
  };

  const removeValue = (value: string) => {
    const newValues = (column.getFilterValue() as unknown[]).filter((v) => v !== value);
    column.setFilterValue(newValues ? newValues : []);
    setInputValue('');
  };

  const addValue = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key !== 'Enter') return;
    const filterValue = (column.getFilterValue() as unknown[]) ?? [];
    if (filterValue.includes(inputValue)) return;
    const newValues = [...filterValue, inputValue];
    column.setFilterValue(newValues);
    setInputValue('');
  };

  return (
    <Popover autoFocus closeOnBlur isLazy placement="top-end">
      <Popover.Trigger>
        {filterValue.length === 0 ? (
          <IconButton aria-label="Menu" icon={<Filter />} size="xs" variant="ghost" />
        ) : (
          <IconButton aria-label="Menu" icon={<FilterBold />} size="xs" variant="ghost" />
        )}
      </Popover.Trigger>
      <Portal>
        <Popover.Content padding={4}>
          <Input
            autoFocus
            onChange={handleInputUpdate}
            onKeyUp={addValue}
            placeholder="Start typing..."
            value={inputValue}
          />
          <Flex>
            {filterValue.map((value) => (
              <Tag key={value as string} mr={2} mt={2}>
                <Tag.Label>{value as string}</Tag.Label>
                <Tag.CloseButton onClick={() => removeValue(value as string)} />
              </Tag>
            ))}
          </Flex>
        </Popover.Content>
      </Portal>
    </Popover>
  );
};
